import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { VerifyEmailComponent } from './verify-email.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ProfilePictureModule } from 'src/app/shared-layout/Components/profile-picture/profile-picture.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [VerifyEmailComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    SharedLayoutModule,
    WithTooltipModule,
    LazyLoadImageModule,
    ProfilePictureModule,
    TranslateModule
  ],
  exports: [VerifyEmailComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class VerifyEmailModule {}
